module.exports = __webpack_public_path__ + "static/media/first_aid_kit.359270bb.svg";